import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    DialogActions,
    DialogContent, FormControl,
    FormControlLabel, FormLabel,
    Radio,
    RadioGroup, TextField
} from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';


type CarDialogProps = {
    makers: string[],
    models: string[],
} & ModalActionProps<{
    make: string,
    model: string
    makeAlt: string,
    modelAlt: string
}>

const ConfirmModelDialog = ({makers, models, onFinish}: CarDialogProps) => {
    const {t} = useTranslation('cars');

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const data = new FormData(event.currentTarget);
        onFinish({
            make: data.get('make') as string,
            model: data.get('model') as string,
            makeAlt: data.get('make_alt') as string,
            modelAlt: data.get('model_alt') as string,
        });
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <Box>
                    {makers.length > 1 && (
                        <FormControl>
                            <FormLabel id="make">{t('make')}</FormLabel>
                            <RadioGroup
                                aria-labelledby="make"
                                name="make"
                                defaultValue={makers[0]}
                            >
                                {makers.map(m => <FormControlLabel key={m} value={m} control={<Radio/>} label={m}/>)}
                            </RadioGroup>
                        </FormControl>
                    )}

                    <TextField
                        id="make_alt"
                        name="make_alt"
                        label={makers.length > 1 ? t('or_write_here') : t('make')}
                        fullWidth
                        defaultValue={makers.length === 1 ? makers[0] : undefined}
                        variant="outlined"
                    />
                </Box>
                <Box>
                    {models.length > 1 && (
                        <FormControl>
                            <FormLabel id="model">{t('model')}</FormLabel>
                            <RadioGroup
                                aria-labelledby="model"
                                name="model"
                                defaultValue={models[0]}
                            >
                                {models.map(m => <FormControlLabel key={m} value={m} control={<Radio/>} label={m}/>)}
                            </RadioGroup>
                        </FormControl>
                    )}

                    <TextField
                        id="model_alt"
                        name="model_alt"
                        label={models.length > 1 ? t('or_write_here') : t('model')}
                        fullWidth
                        defaultValue={models.length === 1 ? models[0] : undefined}
                        variant="outlined"
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('save')}</Button>
            </DialogActions>
        </Box>
    );
};

export default ConfirmModelDialog;
